import * as yup from "yup"

export const loginSchema = yup.object().shape({
  emailOrUserName: yup
    .string()
    .test("email-or-username", "Please enter a valid email or username", (value) => {
      if (!value) return false;
      const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value); // Email validation
      const isUsername = /^[a-zA-Z0-9!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|-]{3,15}$/.test(value); // Username validation
      return isEmail || isUsername;
    })
    .required("Please enter email or username"),
  password: yup.string().required("Please enter password"),
})
